import React from "react";
import { Home } from "./pages/Home";
type EventsState = "upcoming" | "empty";
type AppProps = {
  showReviewNotes?: boolean;
  eventsState?: EventsState;
};
export function App({
  showReviewNotes = true,
  eventsState = "upcoming"
}: AppProps) {
  // The homepage owns the verdict, answers, intake and community sequence.
  return <Home showReviewNotes={showReviewNotes} showEmptyEvents={eventsState === "empty"} data-id="element-0" data-mp="3fbszyntcbuzj" />;
}